import React from 'react';
import cx from 'classnames';
import Icon, { Icons, IconSize } from '@app/common/components/Icon';
import { VerificationStatus } from '@app/types/UploadADoc';
import styles from './VerificationStatusIcon.module.scss';

type VerificationStatusIconProps = {
    status?: VerificationStatus;
};

export const VerificationStatusIcon: React.FC<VerificationStatusIconProps> = ({
    status = VerificationStatus.PENDING
}) => {
    if (status === VerificationStatus.VERIFIED) {
        return <Icon icon={Icons.VERIFICATION_REQUIRED} className={styles.verified} size={IconSize.SMALLER} />;
    }

    if (status === VerificationStatus.PENDING) {
        return <Icon icon={Icons.VERIFICATION_REQUIRED} className={styles.pending} size={IconSize.SMALLER} />;
    }

    if (status === VerificationStatus.FAILED) {
        return <Icon icon={Icons.VERIFICATION_FAILED} className={styles.failed} size={IconSize.SMALLER} />;
    }

    return null;
};
